export default "__VITE_ASSET__CrbtV3Qb__"